import { useEffect, useState } from 'react';
import api from '../services/api';

// ---------------------------------------------------------------------------
// CompetitionBadge — the year you are looking at, in every header (21 Sep 2026).
//
// From FOOM 2027 on there is more than one competition in the database. Every
// list is scoped to the active one (ACTIVE_COMPETITION_SQL on the server), and
// this says WHICH one that is, on the admin, judge, entrant and viewer headers
// alike, so nobody has to infer the year from the data in front of them.
//
// One request per page load, shared by every header that mounts: the promise is
// cached at module level. It renders nothing until the answer arrives, and
// nothing at all if the request fails — a header must never break over a label.
// ---------------------------------------------------------------------------
let cached = null;

export function loadCompetition() {
  if (!cached) {
    cached = api.get('/api/auth/competition')
      .then((res) => ({ ok: true, competition: res.data.competition }))
      .catch(() => { cached = null; return { ok: false, competition: null }; });
  }
  return cached;
}

export default function CompetitionBadge() {
  const [state, setState] = useState(null);

  useEffect(() => {
    let alive = true;
    loadCompetition().then((s) => { if (alive) setState(s); });
    return () => { alive = false; };
  }, []);

  if (!state || !state.ok) return null;

  const c = state.competition;
  if (!c) {
    return (
      <span className="c-header__year c-header__year--none" title="The last competition has been archived and the next has not been started.">
        no active competition
      </span>
    );
  }

  const finished = c.status === 'finished';
  const paused   = c.status === 'entries_paused' || c.status === 'all_paused';
  const note     = finished ? 'finished' : paused ? 'paused' : null;

  return (
    <span
      className={`c-header__year${finished ? ' c-header__year--finished' : ''}`}
      title={`${c.name} — ${c.status.replace(/_/g, ' ')}`}
    >
      {c.year}{note ? ` · ${note}` : ''}
    </span>
  );
}
